export const locale = {
    lang: 'en',
    data: {
        FORM_VALIDATION: {
            REQUIRED: 'Required field',
            INVALID_DATE: 'Field must have the format {{ format }}',
            MAX_DATE: 'Field must be at most {{ max }}',
            MIN_DATE: 'Field must be at least {{ min }}',
            NOT_WEEKEND: 'Field does not allow weekend',
            URL: 'Field must be a valid URL',
            EMAIL: 'Field must be a valid email',
            MIN_LENGTH: 'Field must have at least {{ min }} characters',
            MAX_LENGTH: 'Field must have at most {{ max }} characters',
            NUMBER: 'Field must be a number',
            NUMBER_INTEGER: 'Field must be an integer',
            MAX_NUMBER: 'Field must be at most {{ max }}',
            MIN_NUMBER: 'Field must be at least {{ min }}',
            LETTER_AND_NUMBER: 'Field only allows letters and numbers',
            MASK: 'Field must be in the correct format',
            UUID: 'Field must be a UUID',
            LETTER: 'Field allows only letters',
            DISABLE_MINUTE: 'Field does not allow minutes',
            REGEXP: 'Field does not match the pattern',
            INVALID_DOCUMENT: 'Invalid document',
            MUST_MATCH: 'The fields do not match',
            MINIMUM_TWO_NAMES: 'Enter the full name (first and last name)',
            DUPLICATE_NAMES_NOT_ALLOWED: 'First and last name cannot be the same',
            STRONG_PASSWORD: 'Password must contain at least one uppercase letter, one lowercase letter, one number and one special character',
            CARD_NUMBER_INVALID: 'Invalid card number',
        },
    },
};
